import {
  GET_ROOM,
  SHOW_ROOM_LOADING,
  ROOM_ERROR,
  GET_ROOM_DETAILS,
  SHOW_EDIT_ROOM_LOADING,
  EDIT_ROOM,
  DELETE_ROOM,
  CREATE_ROOM,
} from '../actions/types';

/**
 * ympshipyard: Build interface for shipyard (new)
 * galing-173: fix loading state for add deck and add room button after deleting or adding.
 */

const initialState = {
  roomlist: [],
  roomID: null,
  roomDetails: null,
  roomLoading: false,
  editRoomLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_ROOM_LOADING:
      return {
        ...state,
        roomLoading: true,
      };
    case SHOW_EDIT_ROOM_LOADING:
      return {
        ...state,
        editRoomLoading: true,
      };
    case GET_ROOM:
      return {
        ...state,
        roomlist: payload,
        roomLoading: false,
      };
    case CREATE_ROOM:
      return {
        ...state,
        roomlist: [payload, ...state.roomlist],
        editRoomLoading: false,
      };
    case EDIT_ROOM:
      return {
        ...state,
        roomlist: state.roomlist.map((team) =>
          team._id === payload._id
            ? {
                ...team,
                name: payload.name,
              }
            : team
        ),
        editRoomLoading: false,
      };
    case GET_ROOM_DETAILS:
      return {
        ...state,
        roomDetails: payload,
      };
    case DELETE_ROOM:
      return {
        ...state,
        roomlist: state.roomlist.filter((team) => team._id !== payload),
        editRoomLoading: false,
        // modification start - 09.12.2022 - galing-173
        roomLoading: false,
        // modification end - 09.12.2022 - galing-173
      };
    case ROOM_ERROR:
      return {
        ...state,
        error: payload,
        roomLoading: false,
      };
    default:
      return state;
  }
}
